module.exports = __webpack_public_path__ + "static/img/red-alert.6f8621bd.svg";